import React, { useMemo } from "react";
import { Cell, flexRender } from "@tanstack/react-table";
import { SHTableCell } from "@components/design-systems";
import { useTheme } from "@mui/system";
import { ModelScreenerRow } from "@models/model-screener/entities/modelScreenerData";
import { MSTableDefaultSizeConstants } from "@pages/managed-accounts/model-screener/constant";

type MSTableVirtualizedCellProps = {
  cell: Cell<ModelScreenerRow, unknown>;
};

export const MSTableVirtualizedCell = React.memo(
  ({ cell }: MSTableVirtualizedCellProps) => {
    const { palette } = useTheme();
    const { getStart, getSize, columnDef } = cell?.column || {};

    const cellContent = useMemo(
      () => flexRender(columnDef?.cell, cell.getContext()),
      [columnDef?.cell, cell],
    );

    const cellStyles: React.CSSProperties = useMemo(
      () => ({
        position: "absolute",
        display: "flex",
        left: getStart(),
        width: getSize(),
        flexShrink: 0,
        height: MSTableDefaultSizeConstants.CellHeight,
        alignItems: "center",
        padding: "10px",
        borderRight: columnDef?.meta?.isLastColumn
          ? `1px solid ${palette.divider}`
          : undefined,
      }),
      [getStart, getSize, columnDef?.meta?.isLastColumn, palette.divider],
    );

    return <SHTableCell style={cellStyles}>{cellContent}</SHTableCell>;
  }
);
